const RUPEE_FORMATTER = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

/** INR amount as `₹1,23,456`; em dash for missing / invalid values. */
export function formatRupee(value?: number | null): string {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return RUPEE_FORMATTER.format(Number(value));
}
